import Script from 'next/script';

export function SendItWrapper() {
  return (
    <>
    <Script
    src="https://actionnetwork.org/widgets/v5/form/send-it-for-climate-virtual-postcard?format=js&source=widget"
    onLoad={() => {
        console.log('Script has loaded')
      }}/>
        <div id='can-form-area-send-it-for-climate-virtual-postcard' className='md:pl-12 lg:pl-24 mr-16'></div>    
        </>
  )
}
